module.exports = __webpack_public_path__ + "img/gradient.93b1bbb5.jpg";